import { ElementViewTemplate, html, slotted } from '@microsoft/fast-element';
import { NatGenRadioCard, RadioCardOptions } from './radio-card';
import { endSlotTemplate, startSlotTemplate } from '../start-end/start-end';
import { staticallyCompose } from '../../foundation/template-helpers';

export function radioCardTemplate<T extends NatGenRadioCard>(
    options: RadioCardOptions = {}
): ElementViewTemplate<T> {
    return html<T>`
        <template
            role="radio"
            aria-checked="${x => x.checked}"
            aria-required="${x => x.required}"
            aria-disabled="${x => x.disabled}"
            @keypress="${(x, c) => x.keypressHandler(c.event as KeyboardEvent)}"
            @click="${(x, c) => x.clickHandler(c.event as MouseEvent)}"
        >
            ${startSlotTemplate(options)}
            <label
                part="label"
                class="${x =>
                    x.defaultSlottedNodes && x.defaultSlottedNodes.length
                        ? "label"
                        : "label label__hidden"}"
            >
                <slot ${slotted("defaultSlottedNodes")}></slot>
            </label>
            ${endSlotTemplate(options)}

            <div part="control" class="control">
                <slot name="checked-indicator">
                    ${staticallyCompose(options.checkedIndicator)}
                </slot>
            </div>
        </template>
    `;
}
